import { render, staticRenderFns } from "./Kur.vue?vue&type=template&id=47eeedb0"
import script from "./Kur.vue?vue&type=script&lang=ts"
export * from "./Kur.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports